
import { defineComponent, onMounted, ref } from 'vue';
import { entertainment } from '../../apis/entertainment';
import { useAuthStore } from '../../stores/auth';
import { useWebStore } from '../../stores/web';
import { useToast } from 'primevue/usetoast';

export default defineComponent({
	name: 'EntertainmentAV',
	components: {

	},
	setup() {
		const auth = useAuthStore();
		auth.hydrate()

		const web = useWebStore();

		const toast = useToast();

		const categories = ref<any[]>([])
		const items = ref<any[]>([])
		const loading = ref(false)

		const handleGetCategoryByType = async (type: number) => {
			try {
				const payload = { type }

				const resp = await entertainment.getCategoryByType(payload)

				if (resp.code !== '0') throw new Error(resp.message)

				categories.value = resp.result || []
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			}
		}

		const handleGetItemListByCategory = async (type: number, id: string, size: number, page: number) => {
			loading.value = true
			try {
				const payload = { type, idCategory: id, size, page }

				const resp = await entertainment.getItemListByCategory(payload)
				if (resp.code !== '0') throw new Error(resp.message)
				items.value = resp.result || []
			} catch (error: any) {
				toast.add({ severity: 'error', summary: 'เกิดข้อผิดพลาดบางอย่าง', detail: error, life: 3000 });
			} finally {
				loading.value = false
			}
		}

		onMounted(() => {
			handleGetCategoryByType(3)
		})

		return {
			categories,
			items,
			loading,
			handleGetItemListByCategory,
		}
	},
})
